module.exports = __webpack_public_path__ + "img/mono_33.6c8c8739.png";